/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SubscriptionPriceFragmentFragment = {
  __typename?: 'SubscriptionPrice';
} & Pick<
  Types.SubscriptionPrice,
  'amountWithVat' | 'amountWithoutVat' | 'currency'
>;

export type SubscriptionPlansQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type SubscriptionPlansQuery = { __typename?: 'Query' } & {
  subscriptionPlans: Array<
    { __typename?: 'SubscriptionPlan' } & Pick<
      Types.SubscriptionPlan,
      'planId' | 'subscriptionType'
    > & {
        price: { __typename?: 'SubscriptionPrice' } & Pick<
          Types.SubscriptionPrice,
          'amountWithVat' | 'amountWithoutVat' | 'currency'
        >;
        sales: Types.Maybe<
          { __typename?: 'SubscriptionSale' } & Pick<
            Types.SubscriptionSale,
            'isProlongation' | 'endDate'
          > & {
              discountedPrice: { __typename?: 'SubscriptionPrice' } & Pick<
                Types.SubscriptionPrice,
                'amountWithVat' | 'amountWithoutVat' | 'currency'
              >;
            }
        >;
      }
  >;
};

export const SubscriptionPriceFragmentFragmentDoc = /*#__PURE__*/ `
    fragment SubscriptionPriceFragment on SubscriptionPrice {
  amountWithVat
  amountWithoutVat
  currency
}
    `;
export const SubscriptionPlansDocument = /*#__PURE__*/ `
    query SubscriptionPlans {
  subscriptionPlans: getActiveSubscriptionPlans {
    planId
    subscriptionType
    price {
      ...SubscriptionPriceFragment
    }
    sales {
      isProlongation
      endDate
      discountedPrice {
        ...SubscriptionPriceFragment
      }
    }
  }
}
    ${SubscriptionPriceFragmentFragmentDoc}`;

export function useSubscriptionPlansQuery(
  options?: Omit<Urql.UseQueryArgs<SubscriptionPlansQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(
    { query: SubscriptionPlansDocument, ...options },
  );
}
